import React from 'react';
import Link from '../components/LocalizedLink';

import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PrivacyPage = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="privacy-page" className="py-16 md:py-24 bg-[var(--color-bg)] min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-[var(--color-primary)] hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('common.torna_home')}
        </Link>

        <h1 className="text-4xl font-extrabold tracking-tight text-[var(--color-text)] mb-8">
          {t('privacy.title')}
        </h1>

        <div className="card-elevated p-8 md:p-12 space-y-8">
          <p className="text-lg text-[var(--color-text-muted)]">{t('privacy.updated')}</p>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s1_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">
              {t('privacy.s1_text')}
              <a href="mailto:info@faccioapp.it" className="text-[var(--color-primary)] hover:underline ml-1">info@faccioapp.it</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s2_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('privacy.s2_text')}</p>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('privacy.s2_1')}</li>
              <li>{t('privacy.s2_2')}</li>
              <li>{t('privacy.s2_3')}</li>
              <li>{t('privacy.s2_4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s3_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('privacy.s3_text')}</p>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('privacy.s3_1')}</li>
              <li>{t('privacy.s3_2')}</li>
              <li>{t('privacy.s3_3')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s4_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('privacy.s4_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s5_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('privacy.s5_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s6_title')}</h2>
            <p className="text-[var(--color-text-muted)] mb-4 leading-relaxed">{t('privacy.s6_text')}</p>
            <ul className="list-disc pl-6 text-[var(--color-text-muted)] space-y-2">
              <li>{t('privacy.s6_1')}</li>
              <li>{t('privacy.s6_2')}</li>
              <li>{t('privacy.s6_3')}</li>
              <li>{t('privacy.s6_4')}</li>
              <li>{t('privacy.s6_5')}</li>
              <li>{t('privacy.s6_6')}</li>
              <li>{t('privacy.s6_7')}</li>
            </ul>
            <p className="text-[var(--color-text-muted)] mt-4 leading-relaxed">
              {t('privacy.s6_contact')}
              <a href="mailto:info@faccioapp.it" className="text-[var(--color-primary)] hover:underline ml-1">info@faccioapp.it</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s7_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('privacy.s7_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s8_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('privacy.s8_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s9_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">{t('privacy.s9_text')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[var(--color-text)] mb-4">{t('privacy.s10_title')}</h2>
            <p className="text-[var(--color-text-muted)] leading-relaxed">
              {t('privacy.s10_text')}
              <a href="mailto:info@faccioapp.it" className="text-[var(--color-primary)] hover:underline ml-1">info@faccioapp.it</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
